import Header from './Header';
import Route from './route';

export default {
  RenderProp: Header,
  mainRoute: Route,
};
